// src/store.ts
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query/react'

import { api } from '@/services'

import AppSlice from './reducers/AppSlice'
import DriverSlice from './reducers/DriverSlice'
import WorkSlice from './reducers/WorkSlice'

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    appSlice: AppSlice,
    driverSlice: DriverSlice,
    workSlice: WorkSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
})

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export default store
